import React from 'react'
import Fade from 'react-reveal/Fade'

import TeamCard from './cards/team'
import GenericCard from './cards/generic'

const ShowcaseMixed = ({ title = '', items = [] }) => {

  const renderItems = (el, i) => {
    switch (el.__typename) {
      case 'WpTeam':
        return <TeamCard key={el.id} {...el} />
      default:
        return <GenericCard key={el.id} {...el} />
    }
  }

  const cards = items?.map(renderItems).filter(el => el)
              
  return (
    <>
      <section className='showcase-mixed'>
        <div className='showcase-mixed__inner'>
          <Fade bottom distance={'40px'}>
            <div className='showcase-mixed__header'>
              {title && <h2 dangerouslySetInnerHTML={{ __html: title }} />}
            </div>
            <div className={`showcase-mixed__list ${cards?.length > 3 ? 'showcase-mixed__list--flex-start' : ''}`}>
              { cards }
            </div>
          </Fade>
        </div>
      </section>
    </>
  )
}

export default ShowcaseMixed